import { Component, Input } from '@angular/core';
import { KpiNames, KpiTypes, TrendIndicatorType } from '@models';

interface TrendConfig {
  icon: string;
  color: string;
}

const TREND_CONFIG_MAP: Record<TrendIndicatorType, TrendConfig> = {
  UP_GREEN: { icon: 'arrow-up-bold', color: '#00a824' },
  DOWN_GREEN: { icon: 'arrow-down-bold', color: '#00a824' },
  UP_RED: { icon: 'arrow-up-bold', color: '#e71316' },
  DOWN_RED: { icon: 'arrow-down-bold', color: '#e71316' }
};

@Component({
  selector: 'kpi-trend-indicator',
  templateUrl: './kpi-trend-indicator.component.html',
  styleUrls: ['./kpi-trend-indicator.component.scss']
})
export class KpiTrendIndicatorComponent {
  @Input() trendIndicator?: TrendIndicatorType;
  @Input() trendChange?: number;
  @Input() kpiType!: KpiTypes;
  @Input() kpiName!: KpiNames | string;
  @Input() showPlaceholder = false;

  get trendConfig(): TrendConfig | undefined {
    return this.trendIndicator ? TREND_CONFIG_MAP[this.trendIndicator] : undefined;
  }

  get trendChangeDisplay(): string {
    if (this.trendChange == null) {
      return this.showPlaceholder ? '--' : '';
    }

    const isSpecialKpi = this.kpiName === 'Clinical material kits shipped';
    const prefix = !isSpecialKpi && this.trendChange > 0 ? '+' : '';

    let value: number;
    switch (this.kpiType) {
      case 'percent':
        value = parseFloat((this.trendChange * 100).toFixed(2));
        break;
      case 'number':
        value = parseFloat(this.trendChange.toFixed(2));
        break;
      case 'days':
        value = Math.trunc(this.trendChange);
        break;
      default:
        value = this.trendChange;
    }

    const suffix = this.kpiType === 'percent' ? '%' : '';
    return `${prefix}${value}${suffix}`;
  }

  get hasTrendChange(): boolean {
    return this.trendChangeDisplay !== '';
  }
}
